<template>
  <div style="margin-top: 1%">
    <div class="history-header">
      <div class="history-content">
        {{$t("mobileType")}}&#160;
        <el-select @change="selectKey($event)" filterable v-model="defaultKey" :popper-append-to-body = "false">
          <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in keysList"></el-option>
        </el-select>
        <el-button round @click="mobileExportData">{{$t("mobileExport")}}</el-button>
      </div>
      <div class="history-content1">
        <p class="history-text">{{$t("mobileTime")}}</p>
        <div class="history-content1-date">
          <div @click="dayData(1)" :class="index1 == 1 ? 'history-content1-dataFun1' : 'history-content1-dataFun'">{{$t("mobileDay")}}</div>
          <div @click="weekData(2)" :class="index1 == 2 ? 'history-content1-dataFun1' : 'history-content1-dataFun'">{{$t("mobileWeek")}}</div>
          <div @click="monthData(3)" :class="index1 == 3 ? 'history-content1-dataFun1' : 'history-content1-dataFun'">{{$t("mobileMonth")}}</div>
          <div @click="customData(4)" :class="index1 == 4 ? 'history-content1-dataFun1' : 'history-content1-dataFun'">{{$t("mobileCustom")}}</div>
        </div>
      </div>
      <div class="history-content2">
        <p class="history-text">{{$t("mobileAggregation")}}</p>
        <div class="history-content2-agg">
          <div @click="maxData(1)" :class="index == 1 ? 'history-content2-aggFun1' : 'history-content2-aggFun'">{{$t("mobileMax")}}</div>
          <div @click="minData(2)" :class="index == 2 ? 'history-content2-aggFun1' : 'history-content2-aggFun'">{{$t("mobileMin")}}</div>
          <div @click="avgData(3)" :class="index == 3 ? 'history-content2-aggFun1' : 'history-content2-aggFun'">{{$t("mobileAvg")}}</div>
        </div>
      </div>
    </div>
    <div :class="valueList.length > 0 ? 'history-bottom' : 'history-bottom1'">
      <div class="proCharts" id="myChart" ></div>
      <div class="history-bottom-sumAvg" :style="setDisplay()">
        <p>{{$t("mobileAvg")}}：{{avg}}</p>
        <p>{{cumulative}}：{{sum}}</p>
        <p>{{$t("mobileInterval")}}：{{addNum}}</p>
      </div>
      <div class="history-bottom-maxMin" :style="setDisplay()">
        <p>{{$t("mobileMax")}}：{{max}}</p>
        <p>{{$t("mobileMin")}}：{{min}}</p>
        <p :style="setEvaporateDisplay()">{{$t("mobileEvaporate")}}：{{evaporationNum}}</p>
        <p :style="setTotalRadiationDisplay()">{{$t("sum")}}：{{mobileTotalRadiationNum}}</p>
        <p :style="cumFlowDisplay()">{{$t("cumFlow")}}：{{cumFlowSum}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {getTimeDeviceHistory} from "../untils/api/home";
  import router from "../router";
  export default {
    name: 'historyData',
    components: {},
    data() {
      return {
        option: {},
        index1: 0,
        index: 0,
        keysList: [],
        defaultKey: '',
        title: '',
        deviceId: {},
        deviceIDStr: '',
        startTime: '',
        endTime: '',
        interval: 0,
        agg: '',
        selectAgg: '',
        max: 0,
        min: 0,
        sum: 0,
        avg: 0,
        addNum:0,
        evaporationNum: 0,
        mobileTotalRadiationNum: 0,
        cumFlowSum:0,
        mobileTotalRadiation: [],
        DateList: [],
        valueList: [],
        totalList: [],
        directoryValueList: [],
        //errorNum: 0,
        disFlg: false,
        cumulative: '',
        dayFlg: true,
        load: null,
        apiFlg: true,
      }
    },

    mounted() {
      if (window.history && window.history.pushState) {
        // 历史记录 插入当前界面
        history.pushState(null, null, document.URL)
        window.addEventListener('popstate', this.goBack, false)
      }
    },

    destroyed() {
      window.removeEventListener('popstate', this.goBack, false)
    },

    methods: {
      /**
       * 获取key，设置下拉选择框
       * @param keysInfo
       * @param device
       */
      getSelectKeys(keysInfo,device) {
        this.keysList = [];

        setTimeout(() => {
          console.log("5 秒后执行的操作");
          // 在这里执行你的逻辑
          let HIFlg = localStorage.getItem("HI") === "HI" ? true : false;
          let TGFlg = localStorage.getItem("TG") === "TG" ? true : false;

          for(let i = 0; i < keysInfo.length; i++){
            let keyJson = {};
            keyJson.id = keysInfo[i];
            keyJson.name = this.$t(keysInfo[i]).split(',')[0];
            this.keysList.push(keyJson);

            if(HIFlg == true && keysInfo[i] == 'ambientHumidity') {
              if(keysInfo.indexOf('ambientTemperature') !== -1) {
                let HIJson = {};
                HIJson.id = "HI";
                HIJson.name = "热量指数";
                this.keysList.push(HIJson);
              }
            }

            if(TGFlg == true && keysInfo[i] == 'ambientHumidity') {
              if(keysInfo.indexOf('ambientTemperature') !== -1) {
                let ATJson = {};
                ATJson.id = "AT";
                ATJson.name =  this.$t('AT').split(',')[0];
                this.keysList.push(ATJson);
              }
            }

            if(this.deviceIDStr !== device.id) {
              this.deviceIDStr = device.id;
              this.disFlg = false;
              this.deviceId = device;
              this.defaultKey = this.keysList[0].id;
              //初期化折线图 title
              this.$t(this.keysList[0].id)[1] === undefined
                ? this.title = this.keysList[0].id
                : this.title = this.$t(this.keysList[0].id).split(',')[0] + '(' + this.$t(this.keysList[0].id).split(',')[1] + ')';
              this.startTime = new Date(moment().subtract(1,"days")).getTime();//初期化 开始时间
              this.endTime = new Date(moment()).getTime();//初期化 结束时间
              this.index = 0; //初期化 日期
              this.index1 = 0;//初期化 聚合按钮
              this.selectAgg = '';// 将标记的聚合功能赋值为空
              this.DateList = [];
              this.valueList = [];
              //首次清空
              this.option = {};
              this.myCharts();//加载折线图
            } else {
              this.deviceIDStr = device.id;
            }
          }
        }, 50); // 5000 毫秒 = 5 秒

      },

      /**
       * 获取选择的key
       * @param event
       */
      selectKey(event) {
        this.defaultKey = event;
        //设置选择的title
        this.$t(event).split(',')[1] === undefined
          ? this.title = this.$t(event)
          :this.title = this.$t(event).split(',')[0] + '(' + this.$t(event).split(',')[1] + ')';
        if(this.index === 0 && this.index1 === 0){
          this.index = 1;//设置默认的日期
          this.index1 = 1;//设置默认的聚合按钮
          this.interval = 0;//设置默认的时间间隔
          this.agg = 'NONE';//设置默认聚合功能
          this.selectAgg = '';// 将标记的聚合功能赋值为空
        }
        this.apiFlg = true;
        this.setLoading();
        this.getSelectValues();//获取历史遥测数据
      },

      /**
       * 点击日按钮获取历史遥测数据
       * @param i
       */
      dayData(i) {
        this.index1 = i;
        this.startTime = new Date(moment().subtract(1,"days")).getTime();
        this.endTime = new Date(moment()).getTime();
        this.setAggInterval();//设置时间间隔以及聚合函数
        if(!this.disFlg) {
          this.index = 1;
          this.disFlg = true;
        }
      },

      /**
       * 点击周按钮获取历史遥测数据
       * @param i
       */
      weekData(i){
        this.index1 = i;//切换按钮样式
        this.startTime = new Date(moment().subtract(7,"days")).getTime();//设置开始日期
        this.endTime = new Date(moment()).getTime();//设置结束日期
        if(this.selectAgg !== ''){//标记的聚合功能不为空
          this.agg = this.selectAgg
        } else {//标记的聚合功能为空
          this.agg = 'MAX'
        }
        if(!this.disFlg){
          this.index = 1;
          this.disFlg = true;
        }
        this.setAggInterval();//设置时间间隔以及聚合函数
      },

      /**
       * 点击月按钮获取历史遥测数据
       * @param i
       */
      monthData(i){
        this.index1 = i;//切换按钮样式
        this.startTime = new Date(moment().subtract(1,"months")).getTime();//设置开始日期
        this.endTime = new Date(moment()).getTime();//设置开始日期
        if(this.selectAgg !== ''){//标记的聚合功能不为空
          this.agg = this.selectAgg
        } else {//标记的聚合功能为空
          this.agg = 'MAX'
        }
        if(!this.disFlg){
          this.index = 1;
          this.disFlg = true;
        }
        this.setAggInterval();//设置时间间隔以及聚合函数
      },

      /**
       * 点击月自定义按钮获取历史遥测数据
       * @param i
       */
      customData(i){
        this.index1 = i;//切换按钮样式
        this.$timeDialog({
          click: (startTime,endTime) => {
            this.startTime = startTime;//设置开始日期
            this.endTime = endTime;//设置开始日期
            if(this.selectAgg !== ''){//标记的聚合功能为空
              this.agg = this.selectAgg
            } else {
              this.agg = 'MAX'//设置时间间隔以及聚合函数
            }
            if(!this.disFlg){
              this.index = 1;
              this.disFlg = true;
            }
            this.setAggInterval();//设置时间间隔以及聚合函数
          },
        })
      },

      /**
       * 点击最大值按钮获取历史遥测数据
       * @param i
       */
      maxData(i) {
        this.index = i;//切换按钮样式
        this.agg = 'MAX';//设置聚合功能
        this.selectAgg = 'MAX';//设置标记的聚合功能
        if(!this.disFlg) {
          this.index1 = 1;
          this.disFlg = true;
        }
        this.setAggInterval();//设置时间间隔以及聚合函数
      },

      /**
       * 点击最小值按钮获取历史遥测数据
       * @param i
       */
      minData(i){
        this.index = i;//切换按钮样式
        this.agg = 'MIN';//设置聚合功能
        this.selectAgg = 'MIN';//设置标记的聚合功能
        if(!this.disFlg) {
          this.index1 = 1;
          this.disFlg = true;
        }
        this.setAggInterval();//设置时间间隔以及聚合函数
      },

      /**
       * 点击平均值按钮获取历史遥测数据
       * @param i
       */
      avgData(i){
        this.index = i;//切换按钮样式
        this.agg = 'AVG';//设置聚合功能
        this.selectAgg = 'AVG';//设置标记的聚合功能
        if(!this.disFlg) {
          this.index1 = 1;
          this.disFlg = true;
        }
        this.setAggInterval();//设置时间间隔以及聚合函数
      },

      /**
       * 设置时间间隔以及聚合函数
       */
      setAggInterval() {
        let intervalTime = this.endTime - this.startTime;
        if(intervalTime <= 86400010){//小于等于1天
          this.agg = 'NONE';
          this.interval = 0;
          this.dayFlg = true;
          this.apiFlg = true;
          this.setLoading();
          this.getSelectValues();
        } else {//大于一天
          this.dayFlg = false;
          this.setIntervalInfo();//区分时间间隔 天 or 月
          this.apiFlg = true;
          this.setLoading();
          this.getSelectValues();
        }
      },

      /**
       * 区分时间间隔 天 or 月
       */
      setIntervalInfo() {
        let intervalDay = (this.endTime - this.startTime) / (1000 * 60 * 60 * 24);//天数
        if(intervalDay > 1 && intervalDay < 30){ // 大于1 并且 小于30
          this.setIntervalDayInfo(intervalDay); //设置1月内间隔
        } else if(intervalDay >= 30) { //大于30
          this.setIntervalMonthInfo(intervalDay); //设置大于1月间隔
        }
      },

      /**
       * 设置1月内间隔
       */
      setIntervalDayInfo(intervalDay) {
        switch (true) {
          case intervalDay > 1 && intervalDay <= 3: //大于1天 小于等于3天
            this.interval = 1000 * 60 * 10;
            break;
          case intervalDay > 3 && intervalDay <= 5: //大于3天 小于等于5天
            this.interval = 1000 * 60 * 15;
            break;
          case intervalDay > 5 && intervalDay <= 10: //大于5天 小于等于10天
            this.interval = 1000 * 60 *30;
            break;
          case intervalDay > 10 && intervalDay <= 20:  //大于10天 小于等于20天
            this.interval = 1000 * 60 * 60;
            break;
          case intervalDay > 20:
            this.interval = 1000 * 60 * 60 * 2;//大于20天
            break;
        }
      },

      /**
       * 设置大于1月间隔
       */
      setIntervalMonthInfo(intervalMonth) {
        switch (true) {
          case intervalMonth >= 30 && intervalMonth < 31://等于30天
            this.interval = 1000 * 60 * 60 * 2;
            break;
          case intervalMonth >= 31 && intervalMonth <= 90: //大于30天 小于等于90天
            this.interval = 1000 * 60 * 60 * 5;
            break;
          case intervalMonth > 90 && intervalMonth <= 180: //大于90天 小于等于180天
            this.interval = 1000 * 60 * 60 * 10;
            break;
          case intervalMonth > 180 && intervalMonth <= 240: //大于180天 小于等于240天
            this.interval = 1000 * 60 * 60 * 12;
            break;
          case intervalMonth > 240: //大于240天
            this.interval = 1000 * 60 * 60 * 24;
            break;
        }
      },

      setLoading(){
        //开启等待画面
        this.load = this.$loading({
          lock: true,
          text: this.$t("mobileLoad"),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },

      /**
       * 获取历史遥测数据
       */
      getSelectValues(){
        let levelRefer = localStorage.getItem('levelRefer'); //获取设置水位值
        let snowRefer = localStorage.getItem('snowRefer');//获取设置学深值
        let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
        let CODJson =  localStorage.getItem('CODJson');//虚拟COD
        let WDFlg = localStorage.getItem("WD") === "WD" ? true : false;
        let min = null;
        let max = null;
        if(CODJson != "null") {
          let parsedCODJson = JSON.parse(CODJson);
          min = parsedCODJson.min;
          max = parsedCODJson.max;
        }
        if(this.apiFlg) {
          //循环标识符
          //this.errorNum ++;
          this.DateList = [];
          this.valueList = [];
          this.directoryValueList = [];
          this.totalList = [];
          this.mobileTotalRadiation = [];
          let param='';
          if(this.defaultKey == 'ammoniaIon') {
            param = 'ammoniaIon,waterPH,waterT';
          } else if(this.defaultKey == 'HI') {
            param = 'ambientHumidity,ambientTemperature';
          } else if(this.defaultKey == 'AT') {
            param = 'ambientTemperature,ambientHumidity,windSpeed';
          } else if(this.defaultKey == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
            param = 'level';
            this.interval = 1000 * 60 * 60;
            this.agg = 'AVG';
            this.index = 3;
          }else {
            param = this.defaultKey;
          }
          getTimeDeviceHistory(this.deviceId.entityType, this.deviceId.id, param, this.startTime, this.endTime, this.interval, this.agg).then(response => {
            //this.errorNum = 0;
            if(this.defaultKey == 'ammoniaIon') {
              let changeResponse = [];
              let amnitroArray = response['ammoniaIon'];
              let waterPHArray = response['waterPH'];
              let waterTArray = response['waterT'];

              if(response.hasOwnProperty('waterPH') && waterPHArray.length > 0) {
                if(waterTArray.length > 0) {
                  let min = Math.min(
                    amnitroArray.length,
                    waterPHArray.length,
                    waterTArray.length
                  );
                  for(let i = 0; i < min; i++) {
                    let amnitroJson = {};
                    let amnitro = parseFloat(amnitroArray[i].value);
                    let waterPH = parseFloat(waterPHArray[i].value);
                    let waterT = parseFloat(waterTArray[i].value);
                    let result = amnitro * Math.pow(10, waterPH - (-0.032 * waterT + 10.042)) + amnitro;
                    let amnitroResult = result.toFixed(2);
                    amnitroJson.ts = amnitroArray[i].ts;
                    amnitroJson.value = amnitroResult;
                    changeResponse.push(amnitroJson);
                  }
                } else {
                  let min = Math.min(
                    amnitroArray.length,
                    waterPHArray.length
                  );

                  for(let i = 0; i < min; i++) {
                    let amnitroJson = {};
                    let amnitro = parseFloat(amnitroArray[i].value);
                    let waterPH = parseFloat(waterPHArray[i].value);
                    let result = amnitro * Math.pow(10, (waterPH - 9.25)) + amnitro;
                    let amnitroResult = result.toFixed(2);
                    amnitroJson.ts = amnitroArray[i].ts;
                    amnitroJson.value = amnitroResult;
                    changeResponse.push(amnitroJson);
                  }
                }
              } else {
                changeResponse = amnitroArray;
              }


              for(let i = 0; i < changeResponse.length; i++) {
                this.valueList.push(parseFloat(parseFloat(changeResponse[i].value).toString()));
                this.DateList.push(this.dateFormat(changeResponse[i].ts).substring(5));
                this.totalList.push({
                  ts: this.dateFormat(changeResponse[i].ts),
                  value: parseFloat(changeResponse[i].value).toString()
                });
              }
              //设置样式
              this.setOptionStyle();
              //关闭等待画面
              this.load.close();
            } else if(this.defaultKey == 'HI') {
              let HIResponse = [];
              let humArray = response['ambientHumidity'];
              let temArray = response['ambientTemperature'];
              let min = Math.min(
                humArray.length,
                temArray.length
              );
              for(let i = 0; i < min; i++) {
                let HIJson = {};
                let HI = this.calculateHeatIndex(parseFloat(temArray[i].value), parseFloat(humArray[i].value)).toFixed(3);
                HIJson.ts = humArray[i].ts;
                HIJson.value = HI;
                HIResponse.push(HIJson);
              }

              for(let i = 0; i < HIResponse.length; i++) {
                this.valueList.push(parseFloat(parseFloat(HIResponse[i].value).toString()));
                this.DateList.push(this.dateFormat(HIResponse[i].ts).substring(5));
                this.totalList.push({
                  ts: this.dateFormat(HIResponse[i].ts),
                  value: parseFloat(HIResponse[i].value).toString()
                });
              }

              //设置样式
              this.setOptionStyle();
              //关闭等待画面
              this.load.close();
            } else if(this.defaultKey == 'AT') {
              let ATResponse = [];
              let temArray = response['ambientTemperature'];
              let humArray = response['ambientHumidity'];
              let speedArray = response['windSpeed'];
              if( temArray == undefined || humArray == undefined || speedArray == undefined) {
                //设置样式
                this.setOptionStyle();
                //关闭等待画面
                this.load.close();
                return;
              }
              let min = Math.min(
                temArray.length,
                humArray.length,
                speedArray.length
              );
              for(let i = 0; i < min; i++) {
                let ATJson = {};
                let AT = this.calculateAT(parseFloat(temArray[i].value), parseFloat(humArray[i].value), parseFloat(speedArray[i].value)).toFixed(2);
                ATJson.ts = temArray[i].ts;
                ATJson.value = AT;
                ATResponse.push(ATJson);
              }

              for(let i = 0; i < ATResponse.length; i++) {
                this.valueList.push(parseFloat(ATResponse[i].value));
                this.DateList.push(this.dateFormat(ATResponse[i].ts).substring(5));
                this.totalList.push({
                  ts: this.dateFormat(ATResponse[i].ts),
                  value: ATResponse[i].value
                });
              }

              //设置样式
              this.setOptionStyle();
              //关闭等待画面
              this.load.close();
            } else if(this.defaultKey == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
              if(JSON.stringify(response) === "{}") {
                this.load.close();
                return;
              }

              let cumSum = 0;
              for (let i = 0; i < response['level'].length; i++) {
                let levelNum = 0;
                if(parseFloat(response['level'][i].value) < 0) {
                  levelNum = 0;
                } else {
                  levelNum = parseFloat(response['level'][i].value);
                }
                cumSum += parseFloat(levelNum.toFixed(4)) * 2399.5;
                this.valueList.push(parseFloat(parseFloat(response['level'][i].value).toFixed(4)));
                this.DateList.push(this.dateFormat(response['level'][i].ts).substring(5));
                this.totalList.push({
                  ts: this.dateFormat(response['level'][i].ts),
                  value: parseFloat(response['level'][i].value).toFixed(4)
                });
              }
              this.cumFlowSum = cumSum.toFixed(4);
              this.setOptionStyle();
              this.load.close();
            } else {
              for(let obj in response){
                for (let i = 0; i < response[obj].length; i++) {
                  if(response[obj][i].ts <= this.endTime){
                    let value;
                    let directoryValue;
                    if(this.defaultKey == 'level' || this.defaultKey == 'Rwater' || this.defaultKey == 'waterlevel') {
                      value = parseFloat(Math.abs(parseFloat(levelRefer) +  parseFloat(response[obj][i].value)).toFixed(4).toString());
                    } else if(this.defaultKey == 'snowHeight' || this.defaultKey == 'snowheight'){
                      value = parseFloat(Math.abs(parseFloat(snowRefer) +  parseFloat(response[obj][i].value)).toFixed(4).toString());
                    } else if(this.defaultKey == 'noise' || this.defaultKey == 'noi' || this.defaultKey == 'noise1' || this.defaultKey == 'noise2') {
                      value = parseFloat(Math.abs(parseFloat(noiseRefer) +  parseFloat(response[obj][i].value)).toFixed(1).toString());
                    } else if(this.defaultKey == 'flowNum') {
                      value = (parseFloat(response[obj][i].value) * 6.28).toFixed(2).toString();
                    } else if(this.defaultKey == 'Rday1') {
                      value = parseFloat((parseFloat(response[obj][i].value) * 0.36).toFixed(2));
                    } else if(this.defaultKey == 'COD') {
                      if(min != null && max != null) {
                        let num = this.calculateCOD(min, max, response[obj][i].value);
                        value = parseFloat(num);
                      } else {
                        value = parseFloat(response[obj][i].value);
                      }
                    } else if(localStorage.getItem('waterFlg') == "water" && (this.defaultKey == 'Amnitro' || this.defaultKey == 'dissolvedoxygen'
                      || this.defaultKey == 'Opacity' || this.defaultKey == 'oRp')) {
                      let num;
                      if(this.defaultKey == 'Amnitro') num = this.calculateWater(0,8,parseFloat(response[obj][i].value)).toFixed(2);
                      if(this.defaultKey == 'dissolvedoxygen') num = this.calculateWater(2,10,parseFloat(response[obj][i].value)).toFixed(2);
                      if(this.defaultKey == 'Opacity') num = this.calculateWater(251,1000,parseFloat(response[obj][i].value)).toFixed(0);
                      if(this.defaultKey == 'oRp') num = this.calculateWater(50,500,parseFloat(response[obj][i].value)).toFixed(0);
                      value = parseFloat(num);
                    } else if(WDFlg == true && obj == 'windDirection') {
                      value = response[obj][i].value + ".0";
                      directoryValue = parseFloat(response[obj][i].value);
                    } else {
                      value = parseFloat(response[obj][i].value);
                    }
                    this.valueList.push(value);
                    if(WDFlg == true && obj == 'windDirection') this.directoryValueList.push(directoryValue);
                    this.DateList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.totalList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: value
                    });
                    this.mobileTotalRadiation.push({
                      ts: response[obj][i].ts,
                      value:value
                    })
                  }
                }
              }
              //设置样式
              this.setOptionStyle();
              //关闭等待画面
              this.load.close();
            }


          }).catch(error => {
            // if(this.errorNum > 4){
            //   this.errorNum = 0;
            //   //首次清空
            //   this.option = {};
            //   this.myCharts();//加载折线图
            //   this.load.close();//关闭等待画面
            // } else {
            //   this.getSelectValues();//获取历史遥测数据
            // }
            this.option = {};
            this.myCharts();//加载折线图
            this.load.close();//关闭等待画面
            console.log("error",error);
            this.$message({
              showClose: true,
              type: "warning",
              message: "数据查询失败，请稍后再试"
            })
          })
        }
      },

      calculateHeatIndex(T, RH) {
        // 系数定义
        const c1 = -42.379;
        const c2 = 2.04901523;
        const c3 = 10.14333127;
        const c4 = -0.22475541;
        const c5 = -0.00683783;
        const c6 = -0.05481717;
        const c7 = 0.00122874;
        const c8 = 0.00085282;
        const c9 = -0.00000199;

        // 热量指数计算
        let HI = c1 + (c2 * T) + (c3 * RH) + (c4 * T * RH) + (c5 * T * T) + (c6 * RH * RH) +
          (c7 * T * T * RH) + (c8 * T * RH * RH) + (c9 * T * T * RH * RH);

        return HI;
      },

      calculateAT(temp, hum, speed) {
        let e = hum/100*6.105*2.71828*17.27*temp/(237.7+temp);
        let AT = 1.07*temp+0.2*e-0.65*speed-2.7;
        return AT;
      },

      calculateCOD(min, max, value) {
        let result = value;
        if(value > max || value < min) {
          result = (Math.random() * (max - min) + min).toFixed(1);
        }
        return result
      },

      calculateWater(min, max, value) {
        value = Math.abs(value);
        if(value == 0) value += 1;
        if (value >= min && value <= max) {
          return value; // 直接返回原值
        }

        if (value < min) {
          let multiplier = 2;
          while (value < min) {
            value *= multiplier;
            if (value >= min) break;
            multiplier = Math.min(multiplier + 1, max / min); // 限制 multiplier 递增幅度
          }
        } else if (value > max) {
          let divisor = 2;
          while (value > max) {
            value /= divisor;
            if (value <= max) break;
            divisor = Math.min(divisor + 1, max / min); // 限制 divisor 递增幅度
          }
        }

        return Math.min(Math.max(value, min), max); // 确保最终值在区间内
      },

      /**
       * 设置样式
       */
      setOptionStyle() {
        let WDFlg = localStorage.getItem("WD") === "WD" ? true : false;
        let that = this;
        if(this.valueList.length === 0){
          this.option = {};
          this.max = 0;
          this.min = 0;
          this.avg = 0;
          this.sum = 0;
          this.addNum = 0;
          this.evaporationNum = 0;
        } else {
          //this.defaultKey === 'TotalRadiation' ? this.cumulative = this.$t("mobileSunshine") : this.cumulative = this.$t("mobileSum");
          if(this.defaultKey === 'TotalRadiation' || this.defaultKey === 'Radiation' || this.defaultKey === 'RadiationR' || this.defaultKey === 'RadiationV'
            || this.defaultKey === 'RadiationL' || this.defaultKey === 'Dradiation' || this.defaultKey === 'Sradiation' || this.defaultKey === 'Hradiation'
            || this.defaultKey === 'Radia' || this.defaultKey === 'TotalRadiation1' || this.defaultKey === 'TotalRadiation2' || this.defaultKey === 'Rad'
            || this.defaultKey === 'solarFlat' || this.defaultKey === 'solarAngle') {
            this.cumulative = this.$t("mobileSunshine");
          } else {
            this.cumulative = this.$t("mobileSum");
          }
          this.max = Math.max(...this.valueList).toFixed(2);//最大
          this.min = Math.min(...this.valueList).toFixed(2);//最小
          if(WDFlg == true && this.defaultKey == 'windDirection') {
            const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
            this.avg  = parseFloat(arrayAverage(this.directoryValueList)).toFixed(2); //平均
          } else {
            const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
            this.avg  = parseFloat(arrayAverage(this.valueList)).toFixed(2); //平均
          }

          this.setSunshine();//求和
          this.setEvaporateData();//蒸发
          this.option = {
            color:['rgb(8,252,7)',],
            title: {
              text: this.title,
              left: 'center', //居中
              textStyle: {
                color: '#ffffff',
                fontSize: 12,
                lineHeight: 35,
                fontWeight: 'normal'
              }

            },
            tooltip: { //提示框
              trigger: 'axis',
              axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'line' // 默认为直线，可选为：'line' | 'shadow'
              },
              formatter: function(params) {
                if(that.title  == '天气状况') {
                  let time = params[0].axisValue; // 获取时间
                  let value = '';
                  switch (parseInt(params[0].data)) {
                    case 0:
                      value = "晴";
                      break;
                    case 16:
                      value = "大雨";
                      break;
                    case 17:
                      value = "中雨";
                      break;
                    case 18:
                      value = "小雨";
                      break;
                    case 32:
                      value = "大毛毛雨";
                      break;
                    case 33:
                      value = "中毛毛雨";
                      break;
                    case 34:
                      value = "小毛毛雨";
                      break;
                    case 50:
                      value = "大雪";
                      break;
                    case 51:
                      value = "中雪";
                      break;
                    case 52:
                      value = "小雪";
                      break;
                    case 64:
                      value = "烟";
                      break;
                    case 80:
                      value = "雾";
                      break;
                    case 96:
                      value = "冰雪或高空坠物";
                      break;
                    case 153:
                      value = "飞虫或异常遮挡";
                      break;
                  }

                  return that.$t('time') + '：' + time + '<br>' + that.$t('Weather') + '：' + value;
                } else {
                  let time = params[0].axisValue; // 获取时间
                  let value = params[0].data; // 获取数值

                  return that.$t('time') + '：' + time + '<br>' + that.$t('value') + '：' + value;
                }
              }

            },
            grid: {
              left: '3%',
              right: '3%',
              bottom: '8%',
              top:'17%',
              containLabel: true //grid区域是否包含坐标轴的刻度标签
            },
            xAxis: {
              type: 'category', //坐标轴类型。
              boundaryGap: true, //坐标轴两边留白策略
              data: this.DateList,
              axisLabel: {//坐标轴刻度标签的相关设置
                // interval:this.DateList.length - 2,
                // rotate: 30,
                interval: 'auto',
                rotate: 0,
                show: true,
                textStyle: {
                  color: '#fff',
                  fontSize :10//字体大小
                },
              },
              axisLine:{//坐标轴轴线相关设置
                show :true,
                lineStyle:{
                  color:'#3a4650'// rgb(2,121,253)
                }
              },
              axisTick:{ //坐标轴刻度相关设置。
                show :false,
              }
            },
            yAxis: {
              type: 'value',
              show: true, //隐藏坐标
              axisLabel: { //y轴的坐标文字
                show: true, //不显示坐标控件
                textStyle: {
                  color: '#fff' //文字的颜色
                },

              },
              max:this.max,//最大值
              min:this.min,
              splitLine:{  //坐标在grid区域的分割线
                show: false,// 不显示网格
                lineStyle: { //设置分割线的样式(图表横线颜色)
                  color: ['#153a8a'] //网格颜色
                }
              },
              axisLine:{//坐标轴轴线相关设置
                show :true,
                lineStyle:{
                  color:'#3a4650'//#3a4650  rgb(2,121,253)
                }
              },
              axisTick:{ //坐标轴刻度相关设置。
                show :false,
              },
            },
            series: [
              {
                type: 'line',
                data: this.valueList,
                symbolSize: 10,
                smooth: true,
                animationDuration: 1000,
                lineStyle:{
                  color:'#02bd72'  //线的颜色
                }
              },
            ],
            dataZoom: [
              {
                endValue: 3, //一次显示10个
                type: 'slider',//有滑动条
                show: true,//是否显示滑动条
                xAxisIndex: [0],//开始下标
                handleSize: 0,//滑动条的左右2个滑动条大小
                height: 20, //滑动条高度
                left: "0%",//左边距离
                right: "0%",//右边距离
                bottom: 0,//底部距离
                borderColor: "#3a4650", //边框颜色
                fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
                borderRadius: 5,//边框弧度
                backgroundColor: "#1c2735",//未选区域中的背景色
                showDataShadow: false, //是否显示数据阴影
                showDetail:false,//拖动时是否显示数值
                realtime: true,// 是否实时更新
                filterMode: "filter",
              },
              {
                //左右滑动
                type: "inside",
                show: true,
                xAxisIndex: [0],
                start: 0,
                end: 100,
              }
            ]
          }
        }
        this.myCharts();//加载折线图
      },

      /**
       * 设置累计值或者辐射日照实数
       */
      setSunshine(){
        if(this.defaultKey === 'TotalRadiation' || this.defaultKey === 'Radiation' || this.defaultKey === 'RadiationR' || this.defaultKey === 'RadiationV'
          || this.defaultKey === 'RadiationL' || this.defaultKey === 'Dradiation' || this.defaultKey === 'Sradiation' || this.defaultKey === 'Hradiation'
          || this.defaultKey === 'Radia' || this.defaultKey === 'TotalRadiation1' || this.defaultKey === 'TotalRadiation2' || this.defaultKey === 'Rad'
          || this.defaultKey === 'solarFlat' || this.defaultKey === 'solarAngle') {
          let timeStamp = 0;
          if(this.dayFlg){ //一天内的总辐射值
            for(let i = 0; i < this.totalList.length - 1; i++) {
              if(parseFloat(this.totalList[i].value) > 1.2) {
                timeStamp += new Date(this.totalList[i].ts).getTime() - new Date(this.totalList[i + 1].ts).getTime();
              }
            }
          } else {//聚合函数的总辐射
            for(let i = 1; i <  this.totalList.length; i++) {
              if(parseFloat(this.totalList[i].value) > 1.2) {
                timeStamp += new Date(this.totalList[i].ts).getTime() - new Date(this.totalList[i - 1].ts).getTime();
              }
            }
          }
          this.addNum = 0;
          this.sum = parseFloat(timeStamp/(1000 * 60 * 60)).toFixed(2);
          this.getMobileTotalRadiation();
        } else {
          let addSum = 0;
          //累计值
          const getSum =  arr => arr.reduce(function(prev,curr,index,arr){return prev + curr;});
          this.sum  = parseFloat(getSum(this.valueList)).toFixed(2);//求和

          if(this.dayFlg){
            for(let i = 0; i < this.totalList.length - 1; i++) {
              addSum += this.totalList[i].value - this.totalList[i + 1].value
            }
            this.addNum = parseFloat(addSum).toFixed(2);
          } else {
            for(let i = 1; i <  this.totalList.length; i++) {
              addSum += this.totalList[i].value - this.totalList[i - 1].value
            }
            this.addNum = parseFloat(addSum).toFixed(2);
          }
        }
      },

      /**
       * 获取蒸发量的值
       */
      setEvaporateData() {
        if(this.defaultKey === 'Evaporation'){
          let num = 0;
          if(this.dayFlg){
            for(let i = 0; i < this.valueList.length -1; i++){
              if(this.valueList[i] - this.valueList[i + 1] <= 0){
                num += -(this.valueList[i] - this.valueList[i + 1]);
              }
            }
            this.evaporationNum = parseFloat(num.toFixed(2));
          } else {
            for(let i = 1; i < this.valueList.length; i++){
              if(this.valueList[i] - this.valueList[i - 1] <= 0){
                num += -(this.valueList[i] - this.valueList[i - 1]);
              }
            }
            this.evaporationNum = parseFloat(num.toFixed(2));
          }
        }
      },

      /**
       *折线图区域是否显示
       */
      setDisplay(){
        if(this.valueList.length === 0){
          return {
            display: 'none'
          };
        }
      },

      /**
       * 蒸发量是否显示
       */
      setEvaporateDisplay() {
        if(this.defaultKey !== 'Evaporation'){
          return {
            display:'none'
          }
        }
      },

      /**
       * 获取总辐射累计值
       */
      getMobileTotalRadiation() {
        if(this.endTime - this.startTime <= 1000 * 60 * 60 * 24) {
          this.mobileTotalRadiation.sort(function (a, b) {
            return b.ts < a.ts ? 1 : -1
          });

          this.getMobileTotalRadiationNum(60, this.mobileTotalRadiation);
        }
        else {
          this.mobileTotalRadiationNum = 0;
          this.$message({
            showClose: true,
            type: "warning",
            message: "查看" + this.$t(this.defaultKey).split(",")[0] + "累计值，请选择24小时内的时间段"
          })
        }
      },

      /**
       * 间隔小于一小时的总辐射累计值
       * @param count
       * @param arr
       */
      getMobileTotalRadiationNum(count, arr) {
        let index = 0;
        let arrTemp = [];
        let defaultTime = arr[0].ts;
        arrTemp.push([]);
        // 遍历原始数组
        for (let i = 0; i < arr.length; i++) {
          if(defaultTime + 1000 * 60 * 60 < arr[i].ts) {
            defaultTime = arr[i].ts;
            index++;
            arrTemp.push([]);
          }
          arrTemp[index].push(arr[i]);
        }

        let totalRadiation = 0;
        for(let i = 0; i < arrTemp.length; i++) {
          let totalSum = 0;
          for(let j = 0; j < arrTemp[i].length; j++) {
            totalSum += parseFloat(arrTemp[i][j].value) / 60;
          }
          totalRadiation += totalSum;
        }
        this.mobileTotalRadiationNum = parseFloat(totalRadiation).toFixed(2);
      },

      /**
       * 间隔大于一小时的总辐射累计值
       * @param count
       * @param arr
       */
      getMobileTotalRadiationNum1(count, arr) {
        let totalRadiation = 0;
        for(let i = 0; i < arr.length; i++) {
          totalRadiation += parseFloat(arr[i].value) * count;
          if(i == arr.length - 1) {
            this.mobileTotalRadiationNum = parseFloat(totalRadiation).toFixed(2);
          }
        }
      },

      /**
       * 总辐射累计值是否显示
       */
      setTotalRadiationDisplay() {
        if(this.defaultKey == 'TotalRadiation' || this.defaultKey == 'Radiation' || this.defaultKey == 'RadiationR' || this.defaultKey == 'RadiationV'
          || this.defaultKey == 'RadiationL' || this.defaultKey === 'Dradiation' || this.defaultKey === 'Sradiation' || this.defaultKey === 'Hradiation'
          || this.defaultKey === 'Radia' || this.defaultKey === 'TotalRadiation1' || this.defaultKey === 'TotalRadiation2' || this.defaultKey === 'Rad'
          || this.defaultKey === 'solarFlat' || this.defaultKey === 'solarAngle'){
          return {
            display:'inline'
          }
        } else {
          return {
            display:'none'
          }
        }
      },

      cumFlowDisplay() {
        if(this.defaultKey == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
          return {
            display:'inline'
          }
        } else {
          return {
            display:'none'
          }
        }
      },

      /**
       * 将时间戳转换成时间格式
       * @param timestamp
       * @returns {string}
       */
      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },
      /**
       *加载折线图
       */
      myCharts(){
        document.getElementById("myChart").removeAttribute("_echarts_instance_");
        let myChartOption = this.$echarts.init(document.getElementById('myChart'));
        myChartOption.setOption(this.option);
        //图表自适应
        window.addEventListener("resize",function(){
          myChartOption.resize()  // myChart 是实例对象
        })
      },

      /**
       * 导出当前显示的数据
       */
      mobileExportData(){
        let name = this.$t(this.defaultKey).split(',')[0];
        let that = this;
        if (that.totalList.length === 0) {
          // alert("该时间区间内没有数据，请重新选择");
          that.$message({
            showClose: true,
            type: "warning",
            message: this.$t("mobileDataError")
          });
          return;
        }
        const {export_json_to_excel} = require('../vendor/Export2Excel');
        const tHeader = [this.$t("mobileExportTime"), this.$t("mobileExportValue"),];
        const filterVal = ['ts', 'value',];
        const list = that.totalList;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data,  name + this.$t("mobileDataList"));

      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },

      /**
       * 返回
       */
      goBack() {
        if(this.load !== null){
          this.load.close();
          this.apiFlg = false;
          this.load = null;
        }
        localStorage.clear();
        router.replace("/");
      },
    }
  }
</script>

<style lang="less">
  @media screen and (max-width: 500px) {
    .el-loading-spinner .el-loading-text {
      font-size:4vw;
    }
    .el-icon-loading {
      font-size: 10vw;
    }
  }
</style>

<style lang="less" scoped>
  @media screen and (max-width: 500px) {
    .history-header {
      width: 100%;
      height: 40vw;
      position: absolute;
      top: 0;
    }

    .history-content {
      text-align: left;
      margin-left: 3%;
      font-size: 4vw;
      color: #ffffff;
      margin-top: 1%;
      margin-bottom: 1.5%;
    }

    .history-text {
      margin-bottom: 1%;
      margin-left: 3%;
      font-weight: bold
    }

    .history-content1 {
      width: 100%;
      height: 12vw;
      margin-bottom: 1.5%;
    }

    .history-content1-date {
      width: 80%;
      margin-left: 10%;
      height: 7vw;
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 4vw;
      line-height: 7vw;
    }

    .history-content1-dataFun {
      width: 25%;
      height: 100%;
      color: #BDC7EC;
      border: thin double #2D405A;
    }

    .history-content1-dataFun1 {
      width: 25%;
      height: 100%;
      color: #ffffff;
      border: thin double #386785;
      background-color: #386785;
    }

    .history-content2 {
      width: 100%;
      height: 12vw;
    }

    .history-content2-agg {
      width: 70%;
      height: 8vw;
      margin-left: 15%;
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 4vw;
      line-height: 8vw;
    }

    .history-content2-aggFun {
      width: 34%;
      height: 100%;
      color: #BDC7EC;
      border: thin double #2D405A;
    }

    .history-content2-aggFun1 {
      width: 34%;
      height: 100%;
      color: #ffffff;
      border: thin double #386785;//#4878fe
      background-color: #386785;
    }

    .history-bottom {
      width: 100%;
      top: 40vw;
      position: absolute;
      bottom: 0.1%;
      background-color: #3a4650;
    }

    .history-bottom1 {
      width: 100%;
      top: 40vw;
      position: absolute;
      bottom: 0.1%;
    }

    .proCharts {
      width: 100%;
      height: 100%;
    }

    .history-bottom-sumAvg {
      position: absolute;
      width: 30vw;
      height:10vw;
      top: 0;
      left: 0vw;
      z-index: 999;
      margin-top: 1vw;
      color: #83e2fd;
      text-align: right;
    }

    .history-bottom-maxMin {
      position: absolute;
      width: 30vw;
      height: 10vw;
      top: 0;
      right: 0;
      z-index: 999;
      margin-top: 1vw;
      text-align: left;
      color: #83e2fd;
    }

    .el-button {
      background-color: #345A7C;
      color: #ffffff;
      border: 1px outset #345A7C;
      width: 15vw;
      font-size: 4vw;
      line-height: 3.5vw;
      margin-left: 17%;
    }

    /deep/ .el-input__inner {
      height: 7vw;
      width: 35vw;
      font-size: 3.5vw;

      background-color: #1c2735;
      outline: none;
      /*border: none;*/
      border: thin double  #34455f;//#15FEDA #1296db
      border-radius: 50px;
      color: #83e2fd;//#1890ff #15FEDA
      appearance: none;
      -webkit-appearance: none;
    }

    .el-select-dropdown__item {
      line-height: 100px;
      height: 6vw;
      font-size: 3.5vw;
    }

    /deep/ .el-input__icon {
      width: 3.5vw;
      line-height: 3.5vw;
    }

    /deep/.el-select-dropdown__wrap,.el-scrollbar__warp {
      min-height: 5rem !important;
      min-width: 1rem !important;
    }

    /deep/.el-select .el-input .el-select__caret{
      color: #83e2fd;
      font-size: 3.5vw;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/historyData.vue